import { BaseModel } from "./BaseModel";
import { CalculationHelper, CalculationModel } from "./CalculationHelper";
import { TabNames } from '../modules/Constants';

export class MECostModel extends BaseModel {

    constructor() {
        super();
        this.TabName = TabNames.ME_COST;
        this.TabIndex = 1;
        this.DataProcessor = new MECostProcessor();
    }
}

export class MECostProcessor {

    process(data) {
        let Calculations = [];
        let Calcs = data.calculations_parsed[1];
        let ExchangeRates = [];
        let Records = [];
        let Headers = [];
        let Years = [];
        let Volumes = [];
        let Currency = data.currency;
        let returnRecords = data.returnRecords ?? false;

        let study = data.study;
        let snapshots = data.snapshots;
        let version = data.version;

        study.exchangeRates.forEach(rate => {
            rate.Item2.Values.forEach(item => {
                ExchangeRates.push({
                    currency: rate.Item1,
                    year: new Date(item.Date).getUTCFullYear(),
                    value: item.Value
                });
            });
        });

        Calcs.forEach(calc => {
            Calculations.push(new CalculationModel(calc.calculationText, calc.calculation, calc.val, calc.amount, ExchangeRates, Currency))
        })

        snapshots.forEach(snapshot => {
            snapshot?.Manufacturing.forEach(manufacturing => {
                manufacturing.Operations.forEach(op => {
                    let spendTiming = op.SpendTiming;

                    let spendTimingYears = spendTiming?.Value?.Fields[0]?.Values;

                    spendTimingYears.forEach(spendTimingYear => {
                        let year = new Date(spendTimingYear.Date).getUTCFullYear();

                        if (Years.findIndex(x => x === year) <= -1) {
                            Years.push(year);
                        }
                    });
                });
            });

            Years = Years.sort((a, b) => a - b);

            snapshots.forEach(snapshot => {
                snapshot.SaleableParts.forEach(part => {
                    let key = new CalculationHelper().getPartKey(part);
                    Volumes[key] = { first: 0, total: 0, years: [] };
    
                    var firstYearIndex = part.CostStudyVolume.Value.Fields[0].Values.findIndex(x => x.Value > 0)
                    if (!firstYearIndex || firstYearIndex == -1) {
                        firstYearIndex = 0
                    }
                    let firstYear = part.CostStudyVolume.Value.Fields[0].Values[firstYearIndex];
                    Volumes[key].first = firstYear.Value;
                    Volumes[key].firstYear = new Date(firstYear.Date).getUTCFullYear();
    
    
                    part.CostStudyVolume.Value.Fields.forEach(volume => {
                        volume.Values.forEach(value => {
                            Volumes[key].total += value.Value;
                            var year = new Date(value.Date).getUTCFullYear();
                            Volumes[key].years[year] = (Volumes[key].years[year] ?? 0) + value.Value;
                        });
                    });

                });

                let totalOptionVolume = snapshot.SaleableParts.reduce((acc, part) => {
                    let key = new CalculationHelper().getPartKey(part);
                    return acc + Volumes[key].total;
                }, 0);

                snapshot.SaleableParts.forEach(part => {
                    let key = new CalculationHelper().getPartKey(part);
                    Volumes[key].optionTotal = totalOptionVolume;
                });
    
            });

            snapshot.SaleableParts.forEach(saleablePart => {
                let bom = saleablePart.Bom.value.parts.concat(...saleablePart.Bom.value.partGroups)
                bom.forEach((compPart) => {
                    let operations  = [];
                    let processes = [];
                    snapshot.Manufacturing.filter(process => {
                        let found = process.Parts.find(part => part?.Value?.Fields[0]?.Number?.Fields[0] == compPart.partId.partNumber 
                            && (part?.Value?.Fields[0]?.DrawingRevision?.Fields[0] ?? "") === (compPart.partId.drawingRevision ?? "")
                            && (part?.Value?.Fields[0]?.Suffix?.Fields[0]?.Fields[0] ?? "" ) === (compPart.partId.suffix ?? ""));
                        return found ? true : false;
                    }).forEach(process => {
                        processes.push(process);
                        operations.push(...process.Operations);
                    })

                    var model = new MECostRecord(version, snapshot, saleablePart, compPart, operations, processes, study.burdenRates, Currency, ExchangeRates, Years, Volumes);
                        Records.push(model);
                });
            });
        });

        Headers = this.configureHeader(Years);
        let result = {
            headers: Headers,
            display: returnRecords === true ? Records : this.getDisplay(Headers, Records),
            numerics: this.getNumerics(Years)
        };

        return result;
    }

    configureHeader(Years) {
        let header = [
            "Option Name",
            "Saleable Part Number",
            "Saleable Part Revision",
            "Saleable Part Suffix",
            "Component Part Number",
            "Component Part Revision",
            "Component Part Suffix",
            "Component Part Name",
            "Qty Per Parent",
            "Qty Per Saleable",
            "Production Method",
            "Mfg Plant",
            "Recv Plant", 
            "Calculated Std Hours",
            "Currency",
            "Cost Per Process"
        ];

        Years.forEach(year => {
            header.push("ME Capital " + year);
        });

        Years.forEach(year => {
            header.push("ME Rebill Tooling " + year);
        });

        Years.forEach(year => {
            header.push("ME Non Rebill Tooling " + year);
        });

        Years.forEach(year => {
            header.push("ME Expense " + year);
        });

        return header;
    }

    getDisplay(Headers, Records) {

        let display = [];

        display.push(Headers);

        Records.forEach((record) => {
           
            let row = [
                record.OptionName,
                record.SaleablePartNumber,
                record.SaleablePartRevision,
                record.SaleablePartSuffix,
                record.ComponentPartNumber,
                record.ComponentPartRevision,
                record.ComponentPartSuffix,
                record.ComponentPartName,
                record.QtyPerParent,
                record.QtyPerSaleable,
                record.ProductionMethod,
                record.MfgPlant,
                record.RecvPlant,
                record.CalculatedStdHours, 
                record.Currency, 
                record.CostPerProcess
            ];

            record.Capital.forEach(cap => {
                row.push(cap);
            });

            record.RebillTooling.forEach(tool => {
                row.push(tool);
            });

            record.NonRebillTooling.forEach(tool => {
                row.push(tool);
            });

            record.Expense.forEach(ex => {
                row.push(ex);
            });

            display.push(row);
        });

        return display;
    }

    getNumerics(Years) {
        let numeric = [];

        numeric.push({ start: 13, end: 13});
        numeric.push({ start: 15, end: (Years.length * 4) + 15});

        return numeric;
    }
}

export class MECostRecord {
    OptionName = "";
    SaleablePartNumber = "";
    SaleablePartRevision = "";
    SaleablePartSuffix = "";
    ComponentPartNumber = "";
    ComponentPartRevision = "";
    ComponentPartSuffix = "";
    ComponentPartName = "";
    QtyPerParent = "";
    QtyPerSaleable = "";
    ProductionMethod = "";
    MfgPlant = "";
    RecvPlant = "";
    CalculatedStdHours = "";
    Currency = "";
    CostPerProcess = "";
    Capital = [];
    RebillTooling = [];
    NonRebillTooling = [];
    Expense = [];
    Visible = false;

    constructor(version, snapshot, saleablePart, compPart, operations, processes, burdenRates, Currency, ExchangeRates, Years, Volumes) {

        let helper = new CalculationHelper();
        this.OptionName = snapshot.GroupName;
        this.SaleablePartNumber = saleablePart?.Part?.Number?.Fields[0];
        this.SaleablePartRevision = saleablePart?.Part?.DrawingRevision?.Fields[0];
        this.SaleablePartSuffix = saleablePart?.Part?.Suffix?.Fields[0]?.Fields[0];
        this.ComponentPartNumber = compPart?.partId?.partNumber;
        this.ComponentPartRevision = compPart?.partId?.drawingRevision;
        this.ComponentPartSuffix = compPart?.partId?.suffix;
        this.ComponentPartName = compPart?.name?.value;
        this.QtyPerParent = compPart?.quantityPerParent?.value;
        this.QtyPerSaleable = compPart?.quantityPerSaleable;
        this.ProductionMethod = compPart?.productionMethod?.value?.method;
        this.MfgPlant = compPart?.productionMethod?.value?.manufacturingPlant?.value?.plantNumber;
        this.RecvPlant = compPart?.productionMethod?.value?.receivingPlant?.value?.plantNumber;
        this.Currency = Currency;

        let partKey = helper.getPartKey(saleablePart);
        let partVolume = Volumes[partKey].total;
        let totalVolume = Volumes[partKey].optionTotal;
        let allocation = partVolume / totalVolume;
        

        //JG: Set Up Capital, Tooling, and Expense
        Years.forEach(() => {
            this.Capital.push(0);
            this.RebillTooling.push(0);
            this.NonRebillTooling.push(0);
            this.Expense.push(0);
        });

        if (operations != null) {
            var total = 0;

            operations.forEach(op => {
                let calculatedStdHrs = op.Efficiency?.Value?.Fields[0] > 0 ? (op.CycleTime?.Value?.Fields[0] * op.CrewSize?.Value?.Fields[0]) / (3600 * op.Efficiency?.Value?.Fields[0]) : 0;
                total += isNaN(calculatedStdHrs) ? 0 : calculatedStdHrs;


                let mfgCapitalTotalCost = 0;
                op.ManufacturingCapitalInvestment.forEach(mfgCapitalInvestment => {
                    let vals = mfgCapitalInvestment?.Cost?.Value?.Fields[0]?.Fields[0]?.Values?.map(item => item.Value);
                    let currency = mfgCapitalInvestment?.Cost?.Value?.Fields[0]?.Fields[0]?.Tag
                    let qty = mfgCapitalInvestment?.Quantity?.Value?.Fields[0] ?? 0;
                    let cost = (vals?.length > 0 ? vals?.reduce((prev, next) => prev + next) : 0) * qty;
                    if (currency != Currency) {
                        let converted = helper.exchangeValue(cost, ExchangeRates, new Date().getUTCFullYear(), currency, Currency);
                        cost = converted.displayValue;
                    }
                    mfgCapitalTotalCost += cost;
                });

                let mfgRebillTooling = 0;
                let mfgNonRebillTooling = 0;
                op.ManufacturingToolInvestment.forEach(mfgToolInvestment => {
                    let vals = mfgToolInvestment?.Cost?.Value?.Fields[0]?.Values?.map(item => item.Value);
                    let currency = mfgToolInvestment?.Cost?.Value?.Fields[0]?.Tag
                    let qty = mfgToolInvestment?.Quantity?.Value?.Fields[0] ?? 0;
                    let rebillable = mfgToolInvestment?.IsRebillable?.Value?.Fields[0] ?? false;
                    let cost = (vals?.length > 0 ? vals?.reduce((prev, next) => prev + next) : 0) * qty;
                    if (currency != Currency) {
                        let converted = helper.exchangeValue(cost, ExchangeRates, new Date().getUTCFullYear(), currency, Currency);
                        cost = converted.displayValue;
                    }

                    if (rebillable) {
                        mfgRebillTooling += cost;
                    } else {
                        mfgNonRebillTooling += cost;
                    }
                });

                let mfgExpense = 0;
                op.ManufacturingExpenseInvestment.forEach(mfgExpenseInvestment => {
                    let vals = mfgExpenseInvestment?.Cost?.Value?.Fields[0]?.Values?.map(item => item.Value);
                    let currency = mfgExpenseInvestment?.Cost?.Value?.Fields[0]?.Tag
                    let qty = mfgExpenseInvestment?.Quantity?.Value?.Fields[0] ?? 0;
                    let cost = (vals?.length > 0 ? vals?.reduce((prev, next) => prev + next) : 0) * qty;
                    if (currency != Currency) {
                        let converted = helper.exchangeValue(cost, ExchangeRates, new Date().getUTCFullYear(), currency, Currency);
                        cost = converted.displayValue;
                    }
                        mfgExpense += cost;
                });

                Years.forEach(year => {
                    let spendTimingYear = op.SpendTiming.Value.Fields[0].Values.find(x => new Date(x.Date).getUTCFullYear() == year);
                    let capital = mfgCapitalTotalCost * (spendTimingYear?.Value ?? 0);
                    let rebillTooling = mfgRebillTooling * (spendTimingYear?.Value ?? 0);
                    let nonRebillTooling = mfgNonRebillTooling * (spendTimingYear?.Value ?? 0);
                    let expense = mfgExpense * (spendTimingYear?.Value ?? 0);
                    this.Capital[Years.indexOf(year)] += capital * allocation;
                    this.RebillTooling[Years.indexOf(year)] += rebillTooling * allocation;
                    this.NonRebillTooling[Years.indexOf(year)] += nonRebillTooling * allocation;
                    this.Expense[Years.indexOf(year)] += expense * allocation;

                });
            });

            this.CalculatedStdHours = total;
        }

        let totalBurden = 0;
        if (burdenRates != null && processes != null) {
            let burdenRatesWithoutCurrDep = burdenRates.map(brate => {
                brate.Item2 = brate.Item2.filter(rate => rate.Tag.Item1.Type.Fields[0] != 'Current Depreciation');
                return brate;
            });

            processes.forEach(process => {
                let processBurdenRate = burdenRatesWithoutCurrDep.find(brate => brate.Item1.Fields[0].Number.Fields[0] == process.Plant.Value.Fields[0].Number.Fields[0] && brate.Item1.Fields[2].Fields[0] == process.ProcessType.Value.Fields[0].Fields[0]);
                if (processBurdenRate) {
                    var sameCurrency = processBurdenRate.Item2.filter(rate => rate.Tag.Item2 == Currency);
                    var diffCurrency = processBurdenRate.Item2.filter(rate => rate.Tag.Item2 != Currency);
                    var totalBurdenRate = sameCurrency.reduce((acc, rate) => acc + rate.Values[0].Value, 0);
    
                    diffCurrency.forEach(rate => {
                        let converted = helper.exchangeValue(rate.Values[0].Value, ExchangeRates, new Date().getUTCFullYear(), rate.Tag.Item2, Currency);
                        totalBurdenRate += converted.displayValue;
                    });
    
                    
                    totalBurden += isNaN(totalBurdenRate) ? 0 : totalBurdenRate;
                }
            
            });

            this.CostPerProcess = totalBurden * this.CalculatedStdHours;
        }

        this.Capital = this.Capital.map(x => x == 0 ? "" : x);
        this.RebillTooling = this.RebillTooling.map(x => x == 0 ? "" : x);
        this.NonRebillTooling = this.NonRebillTooling.map(x => x == 0 ? "" : x);
        this.Expense = this.Expense.map(x => x == 0 ? "" : x);

        this.Visible = this.CostPerProcess > 0 || this.Capital.some(x => x > 0) || this.RebillTooling.some(x => x > 0) || this.NonRebillTooling.some(x => x > 0) || this.Expense.some(x => x > 0);
    }

}